import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetUsersErrorAction implements Action {
  public static readonly type = 'GetUsersErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetUsersErrorAction.type;
}
